import React from "react";
import { default as MUITable } from "@mui/material/Table";
import styled from "styled-components";

const StyledMUITable = styled(MUITable)``;

export const Table = (props) => {
  return <StyledMUITable {...props} />;
};
